import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import { toast } from 'react-toastify';
import {
  getItemByItemId,
  updateItem,
  getComboItemById,
  getItemThirdPartyPrices,
  setItemThirdPartyPrice,
  deleteItemThirdPartyPrice,
} from '../../../../../../../../../../crud/menu_api/items';
import { GetAllThirdPartyProviders } from '../../../../../../../../../../crud/configuration_api/third_party_providers';
import { getAllIngredientsByItemId } from '../../../../../../../../../../crud/menu_api/ingredients';
import { IngredientSelection,Option } from '../../../../types';
import './UpdateItem.scss';
import MiniLoadingSpinner from '../../../../../../../../../../components/Spinners/MiniLoadingSpinner';
import { Item, ItemStock } from '../../../../../../types';
import { getStorageUnitsByLocalId } from '../../../../../../../../../../crud/management_api/storage_units';
import FormNavigation from '../CreateItem/components/FormNavigation/FormNavigation';
import BasicInfoSection from '../CreateItem/components/BasicInfoSection/BasicInfoSection';
import AdvanceInfoSection from '../CreateItem/components/AdvanceInfoSection/AdvanceInfoSection';
import AdditionsInfoSection from '../CreateItem/components/AdditionsInfoSection/AdditionsInfoSection';
import UpdateMediaUploadSection from './components/UpdateMediaUploadSection/UpdateMediaUploadSection';
import { getUnidadesMedidaOptions, getCategoryOptions } from '../../../functions/functions';

interface UpdateModalProps {
  show: boolean;
  handleClose: () => void;
  item: any;
  items: any[];
  setItems: any;
  setData: (data: any[]) => void;
  originalItems: Item[];
  setOriginalItems: (data: Item[]) => void;
  categoryId?: string | null;
}


const UpdateItem: React.FC<UpdateModalProps> = ({ show, handleClose, categoryId, item, items, setItems, setData, originalItems, setOriginalItems }) => {
  const [itemName, setItemName] = useState('');
  const [label, setLabel] = useState('');
  const [isDelivery, setIsDelivery] = useState(false);
  const [price, setPrice] = useState('');
  const [price_delivery, setPriceDelivery] = useState('');
  const [isOnline, setIsOnline] = useState(false);
  const [price_online, setPriceOnline] = useState('');
  const [isDesk, setIsDesk] = useState(false);
  const [priceDesk, setPriceDesk] = useState('');
  const [isCombo, setIsCombo] = useState(false);
  const [isStock, setIsStock] = useState(false);
  const [isComboGroup, setIsComboGroup] = useState(false);
  const [currentStock, setCurrentStock] = useState('');
  const [minQuantity, setMinQuantity] = useState('');
  const [description, setDescription] = useState('');
  const [gluten, setGluten] = useState(false);
  const [vegano, setVegano] = useState(false);
  const [sodio, setSodio] = useState(false);
  const [lactosa, setLactosa] = useState(false);
  const [azucar, setAzucar] = useState(false);
  const [alcohol, setAlcohol] = useState(false);
  const [vegetariano, setVegetariano] = useState(false);
  const [picante, setPicante] = useState(false);
  const [imageFiles, setImageFiles] = useState<File[]>([]);
  const [mainImage, setMainImage] = useState('');
  const [imageList, setImageList] = useState<string[]>([]);
  const [imagesToDelete, setImagesToDelete] = useState<string[]>([]);
  const [unidadesMedida, setUnidadesMedida] = useState<any[]>([]);
  const [unidadMedidaId, setUnidadMedidaId] = useState(0);
  const [selectedUnidadName, setSelectedUnidadName] = useState('Seleccionar unidad');
  const [ingredientSelections, setIngredientSelections] = useState<IngredientSelection[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedStorageUnit, setSelectedStorageUnit] = useState(item?.storage_unit_id || null);
  const [storageUnits, setStorageUnits] = useState<any[]>([]); // Agregado para manejar storageUnits
  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null | undefined>(Number(categoryId));
  const [selectedCategoryName, setSelectedCategoryName] = useState('Seleccione una categoría');
  const [menuCategories, setMenuCategories] = useState<Option[]>([]);
  // Workstation override state
  const [workstationId, setWorkstationId] = useState<number | null>(null);
  
  // Navigation state
  const [activeTab, setActiveTab] = useState<'basic' | 'advanced' | 'additions'>('basic');
  // NEW: explicit stock management mode like in CreateItem
  const [stockManagementMode, setStockManagementMode] = useState<'item' | 'ingredients' | null>(null);
  
  // Additions state for selection groups and modifiers
  const [additions, setAdditions] = useState<any>({
    selection_groups: [],
    modifiers: []
  });

  // Granel (by weight/volume) state
  const [isGranel, setIsGranel] = useState(false);
  const [selectedUnidadMedidaId, setSelectedUnidadMedidaId] = useState(0);
  const [selectedUnidadMedidaName, setSelectedUnidadMedidaName] = useState('Seleccione unidad');
  
  // NEW: Track whether stock control was enabled when the modal opened
  const [wasStockControlEnabled, setWasStockControlEnabled] = useState(false);
  
  // NEW: Item stocks array
  const [itemStocks, setItemStocks] = useState<ItemStock[]>([]);

  // Third-party provider pricing state
  const [thirdPartyProviders, setThirdPartyProviders] = useState<{ third_party_provider_id: number; name: string }[]>([]);
  const [thirdPartyPrices, setThirdPartyPrices] = useState<{ [providerId: number]: string }>({});
  const [initialThirdPartyPrices, setInitialThirdPartyPrices] = useState<{ [providerId: number]: string }>({});

  // localId extracted from localStorage
  const userContext = localStorage.getItem('user');
  const localId = userContext != null ? parseInt(JSON.parse(userContext).local_id, 10) : 0;
  // Validation state for stock configuration (to disable Update button)
  const [stockConfigValid, setStockConfigValid] = useState(true);

  const mappedMenuCategories = React.useMemo(() => {
    return menuCategories.map(cat => ({
      id: cat.id,
      name: cat.name,
      subcategories: [],
      items: []
    }));
  }, [menuCategories]);

  // Reset additions state when modal closes or item changes
  useEffect(() => {
    if (!show) {
      // Reset additions when modal closes
      setAdditions({
        selection_groups: [],
        modifiers: []
      });
    }
  }, [show]);

  // Reset additions when item changes
  useEffect(() => {
    setAdditions({
      selection_groups: [],
      modifiers: []
    });
  }, [item?.id]);

  useEffect(() => {
    if (item && show) {
      setLoading(true);
      const user = localStorage.getItem('user');
      const localId = user != null ? JSON.parse(user).local_id : 0;

      Promise.all([
        getUnidadesMedidaOptions(),
        getItemByItemId(item.id),
        getAllIngredientsByItemId(item.id),
        item.isCombo ? getComboItemById(item.id) : Promise.resolve({ data: { items: [] } }),
        getStorageUnitsByLocalId(localId),
        getCategoryOptions(),
      ])
        .then(([unidadResponse, itemResponse, ingredientResponse, comboResponse, storageUnitsResponse, categoryResponse]) => {
          const itemData = itemResponse.data;
          for(let i = 0; i < storageUnitsResponse.data.length; i++) {
            if (storageUnitsResponse.data[i].is_default=== true) {
              setSelectedStorageUnit(storageUnitsResponse.data[i].storage_unit_id);
              break;
            }
          }

          // Populate the fields with the item's data
          setItemName(itemData.item_name || '');
          setLabel(itemData.label || '');
          setIsDelivery(itemData.is_delivery || false);
          setPrice(itemData.price?.toString() || '');
          setPriceDelivery(itemData.price_delivery?.toString() || '');
          setIsOnline(itemData.is_online || false);
          setPriceOnline(itemData.price_online?.toString() || '');
          setPriceDesk(itemData.price_desk?.toString() || '');
          setIsDesk(itemData.is_desk || false);
          setDescription(itemData.description || '');
          setIsCombo(itemData.isCombo || false);
          setGluten(itemData.gluten || false);
          setVegano(itemData.vegano || false);
          setSodio(itemData.sodio || false);
          setLactosa(itemData.lactosa || false);
          setAzucar(itemData.azucar || false);
          setAlcohol(itemData.alcohol || false);
          setVegetariano(itemData.vegetariano || false);
          setPicante(itemData.picante || false);
          setUnidadMedidaId(itemData.unidad_medida_id || 0);
          setMinQuantity(itemData.min_quantity?.toString() || '');
          setMainImage(itemData.main_image || '');
          setImageList(itemData.image_list || []);
          setIsStock(itemData.stock_control || false);
          setIsComboGroup(itemData.is_combo_group || false);
          setCurrentStock(itemData.current_stock ? itemData.current_stock.toString() : '');
          
          // Initialize granel state
          setIsGranel(itemData.is_granel || false);
          setSelectedUnidadMedidaId(itemData.is_granel ? itemData.unidad_medida_id : 0);
          
          const ingredients = ingredientResponse.data.ingredients.map((ing: any) => ({
            id: ing.ingredient_id,
            name: ing.ingredient_name,
            units: ing.units || 1,
            unidad_medida_id: ing.unidad_medida_id || 1,
            is_twin: ing.is_twin || false, // Include is_twin flag
          }));
          setIngredientSelections(ingredients);

          // Set the stock management mode consistently with CreateItem
          const sc = itemResponse.data.stock_control || false;
          if (sc) {
            // IMPORTANT: If we have exactly ONE ingredient and it's a TWIN, treat it as 'item' mode
            // because twins are not actual ingredients but linked items
            const hasSingleTwinIngredient = ingredients.length === 1 && ingredients[0].is_twin === true;
            
            if (hasSingleTwinIngredient) {
              // Single twin ingredient = treat as item-based stock
              setStockManagementMode('item');
            } else if (ingredients.length > 0) {
              // Regular ingredients = ingredient-based stock
              setStockManagementMode('ingredients');
            } else {
              // No ingredients = item-based stock
              setStockManagementMode('item');
            }
          } else {
            setStockManagementMode(null);
          }
          
          // NEW: Track whether stock control was enabled when the modal opened
          setWasStockControlEnabled(sc);
          
          // NEW: Set item stocks if available
          if (itemData.stocks && Array.isArray(itemData.stocks)) {
            setItemStocks(itemData.stocks);
          } else {
            setItemStocks([]);
          }


          setUnidadesMedida(unidadResponse);

          // Si el ítem tiene una unidad de medida asignada, seleccionarla
          const unidadMedida = unidadResponse.find((um: any) => um.unidad_medida_id === itemData.unidad_medida_id);
          if (unidadMedida) {
            setUnidadMedidaId(unidadMedida.id);
            setSelectedUnidadName(`${unidadMedida.name}`);
          }

          // Set granel unit name if available
          if (itemData.is_granel && itemData.unidad_medida_id) {
            const granelUnidadMedida = unidadResponse.find((um: any) => um.id === itemData.unidad_medida_id);
            if (granelUnidadMedida) {
              setSelectedUnidadMedidaName(granelUnidadMedida.name);
            }
          }

          setStorageUnits(storageUnitsResponse.data); // Asignar storageUnits obtenidos
          setMenuCategories(categoryResponse); // Asignar categorías obtenidas

          // Si el ítem tiene una categoría asignada, seleccionarla
          const itemCategory = categoryResponse.find((cat: Option) => cat.id === itemData.category_id);
          if (itemCategory) {
            setSelectedCategoryId(itemCategory.id);
            setSelectedCategoryName(itemCategory.name);
          }

          // Initialize workstation override with item's workstation if any
          if (typeof itemData.workstation_id !== 'undefined') {
            setWorkstationId(itemData.workstation_id ?? null);
          } else {
            setWorkstationId(null);
          }
        })
        .catch((error) => {
          console.error('Error loading item data:', error);
          toast.error('Error al cargar la información del item');
        })
        .finally(() => setLoading(false));
    }
  }, [item, show]);

  // Fetch third-party providers list
  useEffect(() => {
    GetAllThirdPartyProviders()
      .then((response) => {
        if (response?.data) {
          setThirdPartyProviders(response.data);
        }
      })
      .catch((err) => console.error('Error fetching third party providers:', err));
  }, []);

  // Load existing third-party prices for this item
  useEffect(() => {
    if (item?.id && show) {
      getItemThirdPartyPrices(item.id)
        .then((response: any) => {
          if (response?.data?.prices) {
            const pricesMap: { [providerId: number]: string } = {};
            response.data.prices.forEach((p: any) => {
              pricesMap[p.third_party_provider_id] = p.price.toString();
            });
            setThirdPartyPrices(pricesMap);
            setInitialThirdPartyPrices(pricesMap);
          }
        })
        .catch((err) => console.error('Error fetching item TPP prices:', err));
    }
  }, [item?.id, show]);

  const handleThirdPartyPriceChange = (providerId: number, price: string) => {
    setThirdPartyPrices(prev => ({
      ...prev,
      [providerId]: price
    }));
  };

  const handleThirdPartyPriceBlur = (providerId: number) => {
    const price = thirdPartyPrices[providerId];
    const initialPrice = initialThirdPartyPrices[providerId];
    
    if (price === initialPrice) return;
    if (!item?.id) return;
    
    if (price && parseFloat(price) > 0) {
      setItemThirdPartyPrice(item.id, providerId, parseFloat(price))
        .then(() => {
          setInitialThirdPartyPrices(prev => ({ ...prev, [providerId]: price }));
          toast.success('Precio de proveedor actualizado');
        })
        .catch((err) => {
          console.error('Error setting TPP price:', err);
          toast.error('Error actualizando precio de proveedor');
        });
    } else if (!price || parseFloat(price) === 0) {
      if (initialPrice) {
        deleteItemThirdPartyPrice(item.id, providerId)
          .then(() => {
            setInitialThirdPartyPrices(prev => {
              const next = { ...prev };
              delete next[providerId];
              return next;
            });
            toast.success('Precio de proveedor eliminado');
          })
          .catch((err) => {
            console.error('Error deleting TPP price:', err);
            toast.error('Error eliminando precio de proveedor');
          });
      }
    }
  };

  const fileToBase64 = (file: File): Promise<string> => {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleFormSubmit = async () => {
    setLoading(true);

    const userContext = localStorage.getItem('user');
    const localId = userContext != null ? JSON.parse(userContext).local_id : 0;

    // Limpiar y validar campos de texto
    const cleanedItemName = itemName.trim();
    const cleanedLabel = label.trim();
    const cleanedDescription = description.trim();

    // Validaciones
    if (!cleanedItemName) {
      toast.error('El nombre del item no puede estar vacío');
      setLoading(false);
      return;
    }

    if (!cleanedLabel) {
      toast.error('La abreviatura no puede estar vacía');
      setLoading(false);
      return;
    }

    // Additional validation for stock management modes
    if (isStock) {
      if (stockManagementMode === null) {
        toast.error('Selecciona cómo deseas gestionar el stock');
        setLoading(false);
        return;
      }
      if (stockManagementMode === 'item') {
        // For combo groups, we don't need stock validation as inventory is managed through individual products
        if (!isComboGroup) {
          // Only validate stock fields if stock control is being enabled for the first time
          // (i.e., the item didn't have stock control before)
          const wasStockControlEnabled = item?.stock_control || false;
          
          // Mandatory fields for item-based stock (only for non-combo items)
          // Skip validations if the item already had stock control enabled
          if (!wasStockControlEnabled) {
            if (currentStock === '') {
              toast.error('Ingrese el stock actual del ítem');
              setLoading(false);
              return;
            }
            if (!selectedUnidadName || selectedUnidadName === 'Seleccionar unidad') {
              toast.error('Seleccione una unidad de medida');
              setLoading(false);
              return;
            }
            if (!selectedStorageUnit) {
              toast.error('Seleccione una unidad de almacenamiento');
              setLoading(false);
              return;
            }
          }
        }
      }
      if (stockManagementMode === 'ingredients' && ingredientSelections.length === 0) {
        toast.error('Seleccione al menos un ingrediente para gestionar el stock');
        setLoading(false);
        return;
      }
    }

    try {
      // Procesar imágenes a base64
      const imageFileData = await Promise.all(
        imageFiles.map(async (file) => {
          const base64 = await fileToBase64(file);
          return { name: file.name, data: base64.split(',')[1] };
        })
      );

      // Crear el objeto con los datos actualizados (usando valores limpios)
      const selectionsToSend = (isStock && stockManagementMode === 'item') ? [] : ingredientSelections;
  
  // ⚠️ IMPORTANTE - NOMENCLATURA CRÍTICA ⚠️
  // NO CONFUNDIR ESTOS CAMPOS - SON EXACTAMENTE AL REVÉS DE LO QUE PARECEN:
  // 
  // - label (en BD)     = Nombre EN CARTA (bonito, con tildes)    Ej: "Pizza Margarita"
  // - item_name (en BD) = Nombre INTERNO (normalizado, sin tildes) Ej: "pizza_margarita"
  //
  // En el estado local del componente:
  // - itemName (state) = contiene el nombre normalizado -> va a item_name (BD)
  // - label (state)    = contiene el nombre en carta    -> va a label (BD)
  //
  // Por lo tanto el payload debe ser:
  const updatedItem = {
        item_id: item.id,
        label: cleanedLabel,              // ← Nombre en carta (bonito) va al campo "label" de BD
        item_name: cleanedItemName,       // ← Nombre interno (normalizado) va al campo "item_name" de BD
        price: price === '' ? 0 : Number(price),
        is_delivery: isDelivery,
        price_delivery: price_delivery === '' ? null : Number(price_delivery),
        is_online: isOnline,
        price_online: price_online === '' ? null : Number(price_online),
        is_desk: isDesk,
        price_desk: priceDesk === '' ? null : Number(priceDesk),
        description: cleanedDescription, // Usar valor limpio
        isCombo: isCombo,
        state: true,
        gluten: gluten,
        vegano: vegano,
        sodio: sodio,
        lactosa: lactosa,
        azucar: azucar,
        alcohol: alcohol,
        vegetariano: vegetariano,
        picante: picante,
        category_id: selectedCategoryId ?? item.category_id,
        local_id: Number(localId),
        main_image: mainImage,
        images_to_delete: imagesToDelete,
        unidad_medida_id: isGranel ? selectedUnidadMedidaId : unidadMedidaId,
        units: 1, // Always set to 1
        provider_id: null,
        stock_control: isStock,
        is_combo_group: isComboGroup,
        current_stock: currentStock === '' ? 0 : Number(currentStock),
        min_quantity: minQuantity === '' ? 0 : Number(minQuantity),
        ingredient_selections: selectionsToSend,
        image_files: imageFileData,
        ingredients: selectionsToSend.map(ingredient => ingredient.name),
        storage_unit_id: selectedStorageUnit,
        // NEW: Additions payload for selection groups and modifiers
        selection_groups: additions.selection_groups,
        modifiers: additions.modifiers,
        // Granel (by weight/volume) fields
  is_granel: isGranel,
  // Workstation override; when null, backend should use category default
  workstation_id: workstationId
      };


      // Enviar los datos al servidor
      const response = await updateItem(item.id, updatedItem);

      // Check for successful response (200 status indicates success)
      if ((response as any).status !== 200 && (response as any).status !== 201) {
        throw new Error((response as any).data?.message || 'Error al actualizar item');
      }

      // Handle successful update
      if (response) {
        const ingResp = await getAllIngredientsByItemId(item.id);
        const ingredientes: string[] = ingResp.data.ingredients.map((ing: any) => ing.ingredient_name);
        
        toast.success('Item actualizado exitosamente');
        const updatedItemResponse: Item = {
          ...(response as any).data,
          ingredients: ingredientes,
          tiene_ingredientes : ingredientes.length > 0,
        };

        if (selectedCategoryId != null) {
          (updatedItemResponse as any).category_id = selectedCategoryId;
        }
        if (selectedCategoryName && selectedCategoryName !== 'Seleccione una categoría') {
          (updatedItemResponse as any).category_name = selectedCategoryName;
        }

        // Actualizar la lista de ítems en el estado
        const updatedLocalItems = items.map(existingItem =>
          existingItem.id === item.id ? updatedItemResponse : existingItem
        );

        setItems(updatedLocalItems);
        setData(updatedLocalItems);
        setOriginalItems(originalItems.map(existingItem =>
          existingItem.id === item.id ? updatedItemResponse : existingItem
        ));
        
        // Actualizar los valores en el formulario para reflejar los valores limpios
        setItemName(cleanedItemName);
        setLabel(cleanedLabel);
        setDescription(cleanedDescription);
        
        handleClose();
      }
    } catch (error) {
      console.error('Error updating item:', error);
      toast.error((error as any)?.response?.data?.message || 'Error actualizando item');
    } finally {
      setLoading(false);
    }
  };

  const handleImageFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      setImageFiles((prevFiles) => [...prevFiles, ...Array.from(files)]);
    }
  };

  const handleRemoveImage = (index: number) => {
    setImageFiles((prevFiles) => {
      const updated = [...prevFiles];
      updated.splice(index, 1);
      return updated;
    });
  };

  // --- render principal ---
  return (
    <Modal 
      show={show} 
      onHide={handleClose} 
      centered 
      className="create-item-modal-container"
      enforceFocus={false} // Allow focus outside modal (for SearchDropdown portal)
    >
      <Modal.Header>
        <div className='form-modal-title-container'>
          <Modal.Title className='form-modal-title'>Actualizar ítem</Modal.Title>
        </div>
        <Button variant="none" className='modal-close-button' onClick={handleClose}>
          <X size={24} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        {loading && <MiniLoadingSpinner left='50%' />}
        {!loading && 
        <Form>

          <FormNavigation
            activeTab={activeTab}
            onTabChange={setActiveTab}
          />

          {activeTab === 'basic' && (
            <>
              <BasicInfoSection
                items={items}
                itemName={itemName}
                setItemName={setItemName}
                label={label}
                setLabel={setLabel}
                price={price}
                setPrice={setPrice}
                description={description}
                setDescription={setDescription}
                menuCategories={mappedMenuCategories}
                selectedCategoryId={selectedCategoryId}
                setSelectedCategoryId={setSelectedCategoryId}
                setSelectedCategoryName={setSelectedCategoryName}
                isDelivery={isDelivery}
                isOnline={isOnline}
                setIsDelivery={setIsDelivery}
                setIsOnline={setIsOnline}
                isDesk={isDesk}
                setIsDesk={setIsDesk}
                price_delivery={price_delivery}
                setPriceDelivery={setPriceDelivery}
                priceDesk={priceDesk}
                setPriceDesk={setPriceDesk}
                price_online={price_online}
                setPriceOnline={setPriceOnline}
                imageFiles={imageFiles}
                setImageFiles={setImageFiles}
                currentItemId={item?.id}
                isGranel={isGranel}
                setIsGranel={setIsGranel}
                unidadesMedida={unidadesMedida}
                selectedUnidadMedidaId={selectedUnidadMedidaId}
                setSelectedUnidadMedidaId={setSelectedUnidadMedidaId}
                selectedUnidadMedidaName={selectedUnidadMedidaName}
                setSelectedUnidadMedidaName={setSelectedUnidadMedidaName}
                workstationId={workstationId}
                setWorkstationId={setWorkstationId}
                hideMediaUpload={true}
                thirdPartyProviders={thirdPartyProviders}
                thirdPartyPrices={thirdPartyPrices}
                onThirdPartyPriceChange={handleThirdPartyPriceChange}
                onThirdPartyPriceBlur={handleThirdPartyPriceBlur}
              />

              <UpdateMediaUploadSection
                imageFiles={imageFiles}
                handleImageFileChange={handleImageFileChange}
                handleRemoveImage={handleRemoveImage}
                imageList={imageList}
                mainImage={mainImage}
                setMainImage={setMainImage}
                imagesToDelete={imagesToDelete}
                setImagesToDelete={setImagesToDelete}
              />
            </>
          )}

          {activeTab === 'advanced' && (
            <>
              <AdvanceInfoSection
                vegano={vegano}
                setVegano={setVegano}
                sodio={sodio}
                setSodio={setSodio}
                lactosa={lactosa}
                setLactosa={setLactosa}
                azucar={azucar}
                setAzucar={setAzucar}
                alcohol={alcohol}
                setAlcohol={setAlcohol}
                vegetariano={vegetariano}
                setVegetariano={setVegetariano}
                picante={picante}
                setPicante={setPicante}
                gluten={gluten}
                setGluten={setGluten}
                unidadesMedida={unidadesMedida}
                isStock={isStock}
                setIsStock={(val: boolean) => {
                  setIsStock(val);
                  if (val) {
                    setStockManagementMode((prev) => prev ?? 'item');
                  } else {
                    setStockManagementMode(null);
                  }
                }}
                currentStock={currentStock}
                setCurrentStock={setCurrentStock}
                minQuantity={minQuantity}
                setMinQuantity={setMinQuantity}
                setUnidadMedidaId={setUnidadMedidaId}
                unidadMedidaId={unidadMedidaId}
                selectedUnidadName={selectedUnidadName}
                setSelectedUnidadName={setSelectedUnidadName}
                ingredientSelections={ingredientSelections}
                setIngredientSelections={setIngredientSelections}
                selectedStorageUnit={selectedStorageUnit}
                setSelectedStorageUnit={setSelectedStorageUnit}
                storageUnits={storageUnits}
                stockManagementMode={stockManagementMode}
                setStockManagementMode={setStockManagementMode}
                isComboGroup={isComboGroup}
                setIsComboGroup={setIsComboGroup}
                currentItemId={item?.id}
                wasStockControlEnabled={wasStockControlEnabled}
                itemStocks={itemStocks}
                setItemStocks={setItemStocks}
                localId={localId}
                onValidationChange={(isValid: boolean) => setStockConfigValid(isValid)}
              />
            </>
          )}

          {activeTab === 'additions' && (
            <AdditionsInfoSection
              key={`additions-${item?.id}-${show}`}
              itemId={item?.id}
              itemName={itemName}
              additions={additions}
              onAdditionsChange={(newAdditions) => setAdditions(newAdditions)}
            />
          )}


        </Form>}
      </Modal.Body>
      <Modal.Footer>
        <div className="form-modal-footer-custom">
          <Button className="form-button-cancel" variant="none" onClick={handleClose}>
            Cancelar
          </Button>
          <Button className="form-button-create" variant="none" onClick={handleFormSubmit} disabled={loading || (isStock && stockManagementMode === null) || (isStock && stockManagementMode === 'item' && !stockConfigValid)}>
            Actualizar
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default UpdateItem;
